import {
  COLETA_PHOTO_JPEG_QUALITY,
  COLETA_PHOTO_MAX_BYTES,
  COLETA_PHOTO_MAX_WIDTH,
  COLETA_PHOTO_TARGET_MAX_BYTES,
} from "./mpConstants";

export function getRepresentativeDisplayName() {
  try {
    const vision = JSON.parse(localStorage.getItem("userDetailVision"));
    const detail = JSON.parse(localStorage.getItem("userDetail"));
    return vision?.Nome ?? detail?.Nome ?? "";
  } catch {
    return "";
  }
}

export function formatBRL(value) {
  if (value === "" || value === undefined || value === null) return "—";
  const n = typeof value === "number" ? value : Number(value);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function resolvePrecoMarcaNumerico(precoState) {
  if (precoState !== "" && precoState !== undefined && precoState !== null) {
    const n = Number(precoState);
    if (!Number.isNaN(n) && n > 0) return n;
  }
  return null;
}

/** @deprecated Use resolvePrecoMarcaNumerico */
export function resolvePrecoKarstenNumerico(precoState) {
  return resolvePrecoMarcaNumerico(precoState);
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function loadImageFromDataUrl(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Não foi possível processar a imagem."));
    img.src = dataUrl;
  });
}

function estimateDataUrlBytes(dataUrl) {
  const base64 = String(dataUrl).split(",")[1] || "";
  return Math.ceil((base64.length * 3) / 4);
}

function compressImageDataUrl(dataUrl, maxWidth, quality) {
  return new Promise((resolve, reject) => {
    loadImageFromDataUrl(dataUrl)
      .then((img) => {
        const scale = img.width > maxWidth ? maxWidth / img.width : 1;
        const width = Math.max(1, Math.round(img.width * scale));
        const height = Math.max(1, Math.round(img.height * scale));

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        if (!ctx) {
          reject(new Error("Não foi possível processar a imagem."));
          return;
        }

        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      })
      .catch(reject);
  });
}

export async function processColetaPhotoFile(file) {
  if (!file) {
    throw new Error("Nenhum arquivo selecionado.");
  }

  if (!String(file.type || "").startsWith("image/")) {
    throw new Error("Selecione um arquivo de imagem (JPEG, PNG ou WebP).");
  }

  if (file.size > COLETA_PHOTO_MAX_BYTES) {
    throw new Error("A foto deve ter no máximo 5 MB.");
  }

  const dataUrl = await fileToBase64(file);
  const needsCompression =
    file.size > COLETA_PHOTO_TARGET_MAX_BYTES
    || file.type !== "image/jpeg"
    || estimateDataUrlBytes(dataUrl) > COLETA_PHOTO_TARGET_MAX_BYTES;

  if (!needsCompression) {
    return dataUrl;
  }

  let compressed = await compressImageDataUrl(
    dataUrl,
    COLETA_PHOTO_MAX_WIDTH,
    COLETA_PHOTO_JPEG_QUALITY,
  );

  if (estimateDataUrlBytes(compressed) > COLETA_PHOTO_MAX_BYTES) {
    compressed = await compressImageDataUrl(
      dataUrl,
      Math.min(1280, COLETA_PHOTO_MAX_WIDTH),
      0.72,
    );
  }

  if (estimateDataUrlBytes(compressed) > COLETA_PHOTO_MAX_BYTES) {
    throw new Error(
      "Não foi possível reduzir a foto ao tamanho máximo. Tente outra imagem.",
    );
  }

  return compressed;
}
